import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';

import { LinearProgress, Typography, MenuItem } from '@material-ui/core';

import SmorderActions from '../../models/smorderActions';

class OrderHelpers {

    constructor(props) {
        this.props = props;
    }

    get contextMenuActions() {
        const { value, selectOrderForDeliveryTimeInfo, printOrder, isIncludedInRoute, removeOrderFromRoute, addOrderToRoute, handlePopOverClose, exportOrder } = this.props;
        const actions = [];

        if (this.canSetDelivery()) {
            actions.push({
                key: "deliveryTime",
                action: () => {
                    handlePopOverClose();
                    selectOrderForDeliveryTimeInfo(value);
                },
                label: "Lieferzeit setzen",
            });
        }

        if (this.showPrintButton()) {
            actions.push({
                key: "print",
                action: () => {
                    handlePopOverClose();
                    printOrder(value);
                },
                label: "Drucken",
            });
        }

        if (this.showRoutePlanningButton()) {
            actions.push({
                key: "route",
                action: () => {
                    handlePopOverClose();
                    if (isIncludedInRoute) {
                        removeOrderFromRoute(value);
                        return;
                    }
                    addOrderToRoute(value);
                },
                label: isIncludedInRoute ? 'aus Route entfernen' : 'zu Route hinzufügen',
            });
        }

        if (this.showDeliveryExportButton()) {
            actions.push({
                key: "export-order",
                action: () => {
                    handlePopOverClose();
                    exportOrder(value);
                    
                },
                label: 'Lieferung beauftragen',
            });
        }
        return actions;
    }

    get contextMenuButtons() {
        const { classes } = this.props;
        const buttons = [];

        this.contextMenuActions.forEach(action => {
            buttons.push(
                <Button
                    variant="outlined"
                    style={this.buttonStyle}
                    className={classes.button}
                    onClick={action.action}
                >
                    {action.label}
                </Button>
            );
        });

        return buttons;
    }

    get contextMenuItems() {

        const items = [];

        this.contextMenuActions.forEach(action => {
            items.push(
                <MenuItem
                    key={action.key}
                    onClick={action.action}
                >
                    {action.label}
                </MenuItem>,
            );
        });

        return items;
    }

    get buttonStyle() {
        return {
            color: this.props.value.proceedColor,
            height: '48px',
        }
    };

    canSetDelivery() {
        const { value } = this.props;
        return value.actionsAllowed && value.actionsAllowed.includes(SmorderActions.SetExpectedDeliveryTime);
    }

    showPrintButton() {
        const { value, localSettings } = this.props;

        return value.canPrint && !!localSettings && (localSettings.useEposPrinter || localSettings.printViaService);
    }

    showEventName() {
        const { localSettings } = this.props;

        return !!localSettings && localSettings.showEventName;
    }

    showRoutePlanningButton() {
        const { value, localSettings } = this.props;
        return value.canPrint && !!localSettings && localSettings.enableRouteplanning && value.isDelivery;
    }

    showDeliveryExportButton() {        
        const { value, localSettings } = this.props;
        return !!localSettings && localSettings.showOrderExport && value.isDelivery;
    }

    getOrderBackgroundStyle() {
        const {
            value,
            isRoutePlanning,
            isIncludedInRoute,
            localSettings,
        } = this.props;

        if (value.dispatchEvent) {
            return {
                backgroundColor: '#ffffff',
            }
        }

        if ((value.totalPrice != 0 || value.articles.some(v => v.name.includes('10er-Block'))) && localSettings.nonZeroPriceColor && localSettings.nonZeroPriceColor.startsWith('#')) {
            return {
                backgroundColor: localSettings.nonZeroPriceColor,
            };
        }

        return {
            backgroundColor: isRoutePlanning ? (isIncludedInRoute ? 'yellowgreen' : 'rgba(0,0,0,0.5)') : value.color,
        };
    }

    renderOrderLoadingIndicator() {
        const { value } = this.props;

        if (value.loading)
            return <LinearProgress />;
    }

    renderUserNote() {
        const { value, classes } = this.props;
        if (value.userNote)
            return <Typography className={classes.userNote}>{value.userNote}</Typography>;
    }

    renderNotPaid() {
        const { value, classes } = this.props;
        if (value.note && value.note.toUpperCase().includes('NICHT BEZAHLT'))
            return <Typography className={classes.takeaway}>NICHT BEZAHLT</Typography>;
    }

    renderTakeaway() {
        const { value, classes } = this.props;
        if (value.takeaway || (value.note && value.note.includes('Abholung')))
            return <Typography className={classes.takeaway}>Takeaway</Typography>;
    }

    renderPreOrderTime(renderLabel = true) {
        const { classes, value } = this.props;

        if (!value.pickupTime) {
            return null;
        }

        if (value.slotName) {
            return null;
        }

        let label = value.pickupTimeIsSet ? 'Abholzeit' : 'Abholdatum';

        if (value.isDelivery) {
            label = 'Lieferzeit';
        }
        const dateTimeDevider = value.pickupTimeIsSet ? ' - ' : '';
        const pickupDate = moment().diff(moment(value.pickupDate, 'DD.MM.YYYY'), 'days') !== 0 ? dateTimeDevider + value.pickupDate : '';

        if (!pickupDate && !value.pickupTimeIsSet) {
            return null;
        }

        return (
            <div>
                {renderLabel && <Typography className={classes.headerLabel} color="textSecondary">{label}</Typography>}
                <Typography className={classes.inlineTypography} style={{ color: moment(value.pickupTime, 'HH:mm').isBefore(moment()) ? '#cc0000' : 'black' }}>{value.pickupTimeIsSet ? value.pickupTime : ''}{pickupDate}</Typography>
            </div>
        );
    }

    renderOrderTime(renderLabel = true) {
        const { classes, value } = this.props;

        const label = 'Bestellzeit';

        const orderDate = moment().diff(moment(value.orderDate, 'DD.MM.YYYY'), 'days') !== 0 ? ` - ${value.orderDate}` : '';

        return (
            <div>
                {renderLabel && <Typography className={classes.headerLabel} color="textSecondary">{label}</Typography>}
                <Typography className={classes.inlineTypography}>{value.orderTime}{orderDate}</Typography>
            </div>
        );
    }

    renderSpotLayoutName(renderLabel = true) {
        const { classes, value } = this.props;

        if (!value.spotLayoutName) {
            return null;
        }

        return (
            <div>
                {renderLabel && <Typography className={classes.headerLabel} color="textSecondary">Raum</Typography>}
                <Typography className={classes.inlineTypography}>{value.spotLayoutName}</Typography>
            </div>
        );
    }

    renderEventName() {
        const { classes, value } = this.props;

        if (!value.eventName) {
            return null;
        }

        if (!this.showEventName()) {
            return null;
        }

        return (
            <div>                
                <Typography className={classes.inlineTypography}>{value.eventName}</Typography>
            </div>
        );
    }

    renderSpotName(renderLabel = true) {
        const { classes, value } = this.props;

        if (value.additionalSpotInfo) {
            return (
                <div>         
                    <Typography className={classes.headerLabel} color="textSecondary">Tisch</Typography>       
                    <Typography className={classes.inlineTypography}>{value.additionalSpotInfo.replace('Tische:', '')}</Typography>
                </div>
            )
        }

        if (!value.spotName) {
            return null;
        }        

        return (
            <div>
                {renderLabel && <Typography className={classes.headerLabel} color="textSecondary">{(value.isPreOrder && !value.slotName) ? 'Standort' : 'Tisch'}</Typography>}
                <Typography className={classes.inlineTypography}>{value.spotName}</Typography>
            </div>
        );
    }

    renderNickname(renderLabel = true) {
        const { classes, value } = this.props;

        if (!value.pickupCode && !value.isPreOrder) {
            return null;
        }

        if (!value.pickupName) {
            return null;
        }

        const label = value.isDelivery ? 'Lieferung an' : 'Name';

        return (
            <div>
                {renderLabel && <Typography className={classes.headerLabel} color="textSecondary">{label}</Typography>}
                <Typography className={classes.inlineTypography}>{value.pickupName}</Typography>
            </div>
        );
    }

    renderSlotName(renderLabel = true) {
        const { classes, value } = this.props;

        if (!value.slotName) {
            return null;
        }

        const label = 'Zeitpunkt';

        return (
            <div>
                {renderLabel && <Typography className={classes.headerLabel} color="textSecondary">{label}</Typography>}
                <Typography className={classes.inlineTypography}>{value.slotName}</Typography>
            </div>
        );
    }

    renderPickupCode(renderLabel = true) {
        const { classes, value } = this.props;

        if (!value.pickupCode) {
            return null;
        }

        return (
            <div>
                {renderLabel && <Typography className={classes.headerLabel} color="textSecondary">Bestellcode</Typography>}
                <Typography className={classes.inlineTypography}>{value.pickupCode}</Typography>
            </div>
        );
    }

    renderTelephone(renderLabel = true) {
        const { value, classes } = this.props;

        const { telephone, isDelivery } = value;

        if (!telephone || isDelivery) {
            return null;
        }

        return (
            <div>
                {renderLabel && <Typography className={classes.headerLabel} color="textSecondary">Tel.</Typography>}
                <Typography className={classes.inlineTypography}>{telephone}</Typography>
            </div>
        );
    }

    renderOrderActions = () => {
        const { classes, value, declineOrder, proceedOrder, undoOrder, hideActions, isRoutePlanning, renderAsAccordion, } = this.props;

        const { dispatchEvent } = value;

        if (hideActions || (dispatchEvent && !value.canUndo) || isRoutePlanning) {
            if (renderAsAccordion) {
                return (
                    <div className={classes.actionButtonsContainer}>
                        {this.contextMenuButtons}
                    </div>
                );
            } else {
                return (
                    <CardActions className={classes.cardAction}>
                        {this.contextMenuButtons}
                    </CardActions>
                );
            }
        }

        const declineButton = value.canReject && !dispatchEvent
            ? (<Button
                variant="outlined"
                style={this.buttonStyle}
                className={classes.button}
                disabled={value.loading}
                onClick={() => declineOrder(value)}
            >
                Ablehnen
            </Button>)
            : null;

        const undoButton = value.canUndo && dispatchEvent
            ? (<Button
                variant="outlined"
                style={this.buttonStyle}
                className={classes.button}
                disabled={value.loading}
                onClick={() => undoOrder(value)}
            >
                Rückgängig
            </Button>)
            : null;

        const proceedButton = value.proceedText && !dispatchEvent
            ? (<Button
                variant="outlined"
                style={this.buttonStyle}
                className={classes.button}
                disabled={value.loading}
                key={`order_${value.id}_proceed`}
                onClick={() => proceedOrder(value, value.proceedText)}
            >
                {value.proceedText}
            </Button>)
            : null;

        if (renderAsAccordion) {
            return (
                <div className={classes.actionButtonsContainer}>
                    {declineButton}
                    {proceedButton}
                    {undoButton}
                    {this.contextMenuButtons}
                </div>
            );
        } else {
            return (
                <CardActions className={classes.cardAction} key={`order_${value.id}_cardActions`}>
                    {declineButton}
                    {proceedButton}
                    {undoButton}
                </CardActions>
            );
        }
    }

    renderTotalPrice() {
        const { classes, value } = this.props;

        return (
            <div className={classes.totalPriceWrapper}>
                <Typography className={classes.totalPrice}>Gesamt: {value.totalPrice.toFixed(2).replace('.', ',')}€</Typography>
            </div>
        );
    }

    renderDispatchEvent() {
        const { classes, value } = this.props;
        const { dispatchEvent } = value;

        if (!dispatchEvent) {
            return null;
        }

        const { timestamp, description, note, blockUser } = dispatchEvent;

        const noteComponent = note ?
            (<div><br />
                <Typography className={classes.inlineTypography} color="textSecondary">
                    {note}
                </Typography>
            </div>)
            : null;

        const blockUserComponent = blockUser ?
            (<div>
                <br />
                <Typography className={classes.inlineTypography} color="textSecondary">
                    Benutzer wurde blockiert
                </Typography>
            </div>)
            : null;

        return (
            <div>
                <Typography className={classes.headerLabelWide}>
                    {description}
                </Typography>
                {noteComponent}
                {blockUserComponent}
                <br />
                <Typography className={classes.inlineTypography} color="textSecondary">
                    {moment(timestamp).format('l, HH:MM')}
                </Typography>
            </div >
        );
    }

    renderDeliveryInformation(renderLabel = false) {
        const { classes, value, isRoutePlanning, localSettings } = this.props;

        const { address } = value;

        if (!value.isDelivery) { return null; }

        if (!isRoutePlanning && localSettings && localSettings.showDeliveryAdressInline) {
            return (
                <div>
                    {renderLabel && <Typography className={classes.headerLabel} color="textSecondary">Kontakt</Typography>}
                    <Typography className={classes.deliveryInformation}>{address.companyName}</Typography>
                    <br />
                    <div className={renderLabel && classes.headerLabel} />
                    <Typography className={classes.deliveryInformation}>{address.street}</Typography>
                    <br />
                    <div className={renderLabel && classes.headerLabel} />
                    <Typography className={classes.deliveryInformation}>{address.zip} {address.city}</Typography>
                    <br />
                    <div className={renderLabel && classes.headerLabel} />
                    <Typography className={classes.inlineTypographyDotted}>Details anzeigen</Typography>
                </div>
            );
        }

        return (
            isRoutePlanning ?
                <div>
                    {renderLabel && <Typography className={classes.headerLabel} color="textSecondary">Kontakt</Typography>}
                    <Typography className={classes.deliveryInformation}>{value.pickupName}</Typography>
                    <br />
                    <div className={renderLabel && classes.headerLabel} />
                    <Typography className={classes.deliveryInformation}>{address.companyName}</Typography>
                    <br />
                    <div className={renderLabel && classes.headerLabel} />
                    <Typography className={classes.deliveryInformation}>{address.street}</Typography>
                    <br />
                    <div className={renderLabel && classes.headerLabel} />
                    <Typography className={classes.deliveryInformation}>{address.zip} {address.city}</Typography>
                    <br />
                    <div className={renderLabel && classes.headerLabel} />
                    <Typography className={classes.deliveryInformation}>Stiege: {address.stairway || '-'} / Stock: {address.floor || '-'} / Tür: {address.door || '-'}</Typography>
                </div>
                :
                <div>
                    <Typography className={classes.inlineTypographyDotted}>Adresse {'&'} Kontakt anzeigen</Typography>
                </div>

        );
    }
}

OrderHelpers.defaultProps = {
    hideActions: false,
    showTotalPrice: false,
    isRoutePlanning: false,
    renderAsAccordion: false,
};

OrderHelpers.propTypes = {
    classes: PropTypes.object.isRequired,
    value: PropTypes.object.isRequired,
    proceedOrder: PropTypes.func.isRequired,
    undoOrder: PropTypes.func.isRequired,
    declineOrder: PropTypes.func.isRequired,
    printOrder: PropTypes.func.isRequired,
    openDeliveryDialog: PropTypes.func.isRequired,
    selectOrderForDeliveryTimeInfo: PropTypes.func.isRequired,
    handlePopOverClose: PropTypes.func.isRequired,
    hideActions: PropTypes.bool,
    isRoutePlanning: PropTypes.bool,
    showTotalPrice: PropTypes.bool,
    renderAsAccordion: PropTypes.bool,
    localSettings: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
};

export default OrderHelpers;
